// Whether the Face Tracker viewport chip is shown. A per-browser preference,
// the same shape as graphAdvancedMode.js.
//
// The chip used to be pinned to the middle of the viewport and could not be
// moved or dismissed, so it sat on the avatar's chest. It is parked top-right
// now and carries a × ; this is where "I closed it" survives a reload, and what
// the View menu's tick reads. Dismissing is PURELY visual — the camera keeps
// running, a take in progress keeps recording, and a blocked/failed camera
// shows the chip anyway because Retry is the only way out of those.

const STORAGE_KEY = 'aos-face-chip-hidden'

const listeners = new Set()

function read() {
  if (typeof window === 'undefined') return true
  try { return window.localStorage.getItem(STORAGE_KEY) !== 'true' } catch { return true }
}

let visible = read()

export function isFaceChipVisible() { return visible }

/** Returns an unsubscribe. */
export function subscribeFaceChipVisibility(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function setFaceChipVisible(on) {
  const next = !!on
  if (next === visible) return visible
  visible = next
  if (typeof window !== 'undefined') {
    try { window.localStorage.setItem(STORAGE_KEY, next ? 'false' : 'true') } catch { /* private window */ }
  }
  for (const fn of listeners) {
    try { fn(next) } catch (e) { console.error('[faceTrackChipVisibility] listener threw', e) }
  }
  return visible
}

export function toggleFaceChipVisible() { return setFaceChipVisible(!visible) }

/** Tests only: back to the shipped default without going through a listener storm. */
export function resetFaceChipVisibility() {
  visible = true
  if (typeof window !== 'undefined') {
    try { window.localStorage.removeItem(STORAGE_KEY) } catch { /* private window */ }
  }
  return visible
}
